export default "__VITE_ASSET__718715a8__"